class VwHbsServisveriDTO {
    id?: number = 0;
    bransId: number = null;
    sira?: number = null;
    adi?: string = "";
    tip?: number = null;
    tarihaktif?: string = "H";
    aktif?: string = "E";
    eklemeTarihi?: string = null;
    ekleyenKullanici?: number = null;
};
export default VwHbsServisveriDTO;